import paronApi from '@/utils/paron-api'

export default {
    getOfferTypes() {
        return paronApi.get('offer/types')
    },

    getAllOffers() {
        return paronApi.get('offer/all')
    },

    getOfferById(id) {
        return paronApi.get(`offer/${id}`)
    },

    createOffer(data) {
        return paronApi.post('offer/new', data)
    },

    editOfferById(id, data) {
        return paronApi.post(`offer/${id}/edit`, data)
    },

    deleteOfferById(id) {
        return paronApi.delete(`offer/${id}`)
    },

    getOffersByFilter(page, filter, sortOption, order, perPage = 10) {
        var path = `offer/filtered?page=${page || 1}&per_page=${perPage}`
        if (sortOption) {
            path += `&sortOption=${sortOption}&order=${order || 'ASC'}`
        }
        return paronApi.post(path, filter)
    }

}
